import {
  Button,
  Card,
  IconButton,
  ListProps,
  makeStyles,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import CardTitle from "@saleor/components/CardTitle";
// import Checkbox from "@saleor/components/Checkbox";
import ResponsiveTable from "@saleor/components/ResponsiveTable";
import Skeleton from "@saleor/components/Skeleton";
import { VoucherDetails_voucher_languages } from "@saleor/discounts/types/VoucherDetails";
import { ListActions } from "@saleor/types";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

import { maybe, renderCollection } from "../../../misc";

export interface LanguageChoiceProps extends ListProps, ListActions {
  languageList: VoucherDetails_voucher_languages[];
  onLanguageAssign: () => void;
  onLanguageUnAssign: (id: string) => void;
  disabled: boolean;
}

const useStyles = makeStyles(
  theme => ({
    colActions: {
      "&:last-child": {
        paddingRight: 0
      },
      width: 76 + theme.spacing(0.5)
    },
    colName: {
      paddingLeft: 35,
      width: "auto"
    },

    colPublished: {
      width: 150
    },
    colCode: {
      width: 100
    },
    table: {
      tableLayout: "fixed"
    },
    tableRow: {
      cursor: "pointer"
    }
  }),
  { name: "DiscountProducts" }
);
const LanguageChoice: React.FC<LanguageChoiceProps> = ({
  languageList,
  onLanguageAssign,
  onLanguageUnAssign,
  // selected,
  disabled,
  // toggleAll,
  isChecked
  // toggle
}) => {
  const classes = useStyles();
  const intl = useIntl();
  const numberOfColumns = 2;
  return (
    <>
      <Card>
        <CardTitle
          title={intl.formatMessage({
            defaultMessage: "Voucher Languages",
            description: "section header"
          })}
          toolbar={
            <Button color="primary" onClick={onLanguageAssign}>
              <FormattedMessage
                defaultMessage="Assign languages"
                description="button"
              />
            </Button>
          }
        />
        <ResponsiveTable>
          <colgroup>
            <col className={classes.colName} />
            <col className={classes.colCode} />
            <col className={classes.colActions} />
          </colgroup>
          <TableHead
          // colSpan={numberOfColumns}
          // // selected={selected}
          // disabled={disabled}
          // items={maybe(() => languageList)}
          // toggleAll={toggleAll}
          // toolbar={toolbar}
          >
            <TableCell className={classes.colName}>
              <FormattedMessage defaultMessage="Name" />
            </TableCell>
            <TableCell className={classes.colCode}>
              <FormattedMessage defaultMessage=" Code" />
            </TableCell>
            <TableCell className={classes.colActions} />
          </TableHead>

          <TableBody>
            {renderCollection(
              maybe(() => languageList),
              language => {
                const isSelected = language ? isChecked(language.id) : false;
                return (
                  <TableRow
                    hover={!!language}
                    key={language ? language.id : "skeleton"}
                    className={classes.tableRow}
                    selected={isSelected}
                  >
                    {/* <TableCell padding="checkbox">
                      <Checkbox
                        checked={isSelected}
                        disabled={disabled}
                        disableClickPropagation
                        onChange={() => toggle(language.id)}
                      />
                    </TableCell> */}
                    <TableCell className={classes.colName}>
                      {maybe<React.ReactNode>(
                        () => language.language,
                        <Skeleton />
                      )}
                    </TableCell>
                    <TableCell className={classes.colCode}>
                      {maybe<React.ReactNode>(
                        () => language.languageCode,
                        <Skeleton />
                      )}
                    </TableCell>
                    <TableCell className={classes.colActions}>
                      <IconButton
                        disabled={!language || disabled}
                        onClick={event => {
                          event.stopPropagation();
                          onLanguageUnAssign(language.id);
                        }}
                      >
                        <DeleteIcon color="primary" />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                );
              },
              () => (
                <TableRow>
                  <TableCell colSpan={numberOfColumns}>
                    <FormattedMessage defaultMessage="No languages found" />
                  </TableCell>
                </TableRow>
              )
            )}
          </TableBody>
        </ResponsiveTable>
      </Card>
    </>
  );
};
export default LanguageChoice;
